document.addEventListener("DOMContentLoaded", () => {
  initAccessoryButtonHandler();
  closeDrawerOnOverlayClick();
});

// Hook into Shopify functions
["drawer:updated", "cart:updated", "cart:refresh", "main-cart:updated"].forEach(
  (event) => {
    document.addEventListener(event, () => {
      initAccessoryButtonHandler();
    });
  }
);

const initAccessoryButtonHandler = () => {
  const container = document.querySelector(
    "main, .cart__items, .accessories-list"
  );

  if (!container || container.dataset.accessoryBound === "true") return;
  container.dataset.accessoryBound = "true";

  container.addEventListener("click", async function (e) {
    const button = e.target.closest(".add-accessory-btn");
    if (!button) return;

    e.preventDefault();

    if (button.classList.contains("is--loading")) return;

    button.classList.add("is--loading");
    const variantId = button.dataset.variantId;
    const accessoryElement = button.closest(".horizontal-product");

    try {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!addRes.ok) throw new Error("Failed to add accessory");

      const cart = await fetch("/cart.js").then((res) => res.json());

      const sectionId = document
        .querySelector("cart-items, main-cart")
        ?.getAttribute("data-section-id");
      if (!sectionId) throw new Error("Section ID not found");

      const sectionHtml = await fetch(`?section_id=${sectionId}`).then((res) =>
        res.text()
      );

      cart.sections = {
        [sectionId]: sectionHtml,
      };

      const parser = new DOMParser();
      const parsedHtml = parser.parseFromString(sectionHtml, "text/html");
      const newSection = parsedHtml.querySelector(
        `[data-section-id="${sectionId}"]`
      );
      const currentSection = document.querySelector(
        `[data-section-id="${sectionId}"]`
      );

      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;

        document.dispatchEvent(new CustomEvent("main-cart:updated"));
      }

      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: "accessory-add",
        cart,
      });

      accessoryElement?.remove();
    } catch (err) {
      console.error("Error adding accessory:", err);
    } finally {
      button.classList.remove("is--loading");
    }
  });
};

const closeDrawerOnOverlayClick = () => {
  const drawerContainer = document.querySelector(
    '[id$="__cart-drawer"].shopify-section-group-overlay-group'
  );
  const drawer = drawerContainer?.querySelector("#CartDrawer");

  if (!drawerContainer) return;

  // Close on overlay or close button click
  drawerContainer.addEventListener("click", (event) => {
    const overlay = event.target.closest(".overlay");
    const closeButton = event.target.closest(".cart-drawer__close");

    if (overlay || closeButton) {
      drawer.removeAttribute("open");
      document.body.classList.remove("has-modal-open");
    }
  });

  // Close on esc key press
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer && drawer.hasAttribute("open")) {
      drawer.removeAttribute("open");
      document.body.classList.remove("has-modal-open");
    }
  });
};
